import { Box } from "@mui/material";
import Step from "@mui/material/Step";
import StepContent from "@mui/material/StepContent";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import React from "react";
import { lightScrollbarStyle } from "../../styles/lightScrollbarStyle";
import { HeadingWithTooltip } from "../../components/HeadingWithTooltip";
import { Sam } from "../Workspace/WorkspaceConfiguration/Sam/Sam";
import { Som } from "../Workspace/WorkspaceConfiguration/Som/Som";
import { Tam } from "../Workspace/WorkspaceConfiguration/Tam/Tam";
import { TABS } from "../Workspace/WorkspaceConfiguration/constants";
import { STEPPER_STYLES } from "./constants";

const STEPS_CONTENT_MAPPING: Record<number, React.ReactNode> = {
  0: <Tam />,
  1: <Sam />,
  2: <Som />,
};

export const MarketSizingConfigView: React.FC = () => {
  const renderStepContent = (step: number) => {
    return STEPS_CONTENT_MAPPING[step];
  };

  return (
    <Box
      sx={{
        overflow: "auto",
        height: "100%",
        ...lightScrollbarStyle,
      }}
    >
      <Stepper orientation="vertical" sx={STEPPER_STYLES} connector={<></>}>
        <Step expanded active>
          <StepLabel>
            <HeadingWithTooltip
              title="Total Addressable Market (TAM)"
              tooltip={TABS[0].tooltip}
            />
          </StepLabel>
          <StepContent>{renderStepContent(0)}</StepContent>
        </Step>
        <Step expanded active>
          <StepLabel>
            <HeadingWithTooltip
              title="Serviceable Addressable Market (SAM)"
              tooltip={TABS[1].tooltip}
            />
          </StepLabel>
          <StepContent>{renderStepContent(1)}</StepContent>
        </Step>
        <Step expanded active>
          <StepLabel>
            <HeadingWithTooltip
              title="Serviceable Obtainable Market (SOM)"
              tooltip={TABS[2].tooltip}
            />
          </StepLabel>
          <StepContent>{renderStepContent(2)}</StepContent>
        </Step>
      </Stepper>
    </Box>
  );
};
